import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseService} from 'public-shared/services/base-http/base.service';
import {Observable} from 'rxjs';
import {Ruleset} from 'shared/services/settings/ruleset.dto';
import {RulesetEndpoint} from 'shared/services/endpoint-constants';
import {BaseEndpoints} from 'public-shared/models/endpoints/base-endpoint.constants';

/**
 * This service will be used to fetch the ruleset, and it can be shared across
 * multiple components. For now, it is used in Global Settings -> Platform Settings
 */
@Injectable()
export class RulesetService extends BaseService {
  constructor(protected override http: HttpClient) {
    super(http);
    this.baseUrl = BaseEndpoints.V1;
  }

  public getRulesets$(): Observable<Ruleset[]> {
    return this.get$<Ruleset[]>(RulesetEndpoint.GLOBAL);
  }
}
